export default "__VITE_ASSET__ChC4qb0V__"